import { AbstractControlDirective, AbstractControl } from '@angular/forms';

export default class UtilForm {

  /**
   * Returns a boolean to show that the parameter passed AbstractControl is invalid
   *
   * @param {AbstractControlDirective | AbstractControl} control
   * @return {boolean}
   */
  static isInvalidControl(control: AbstractControlDirective | AbstractControl): boolean {
    if (control && control.getError('required')) {
      return control && control.errors && (control.dirty || control.touched);
    }

    return control && control.errors && control.dirty && control.touched;
  }

}
